export const API_SEGMENT = '/menu/service'
export const API_VERSION = '1.0'

export const RENDER_AS_MENU = 'menu'
export const RENDER_AS_HEADER = 'header'
export const RENDER_AS_BOTH = 'both'
export const RENDER_AS_SELECT = 'select'
